import { render, staticRenderFns } from "./DownloadInvoice.vue?vue&type=template&id=6b81b144&"
import script from "./DownloadInvoice.vue?vue&type=script&lang=js&"
export * from "./DownloadInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports